import styled from "styled-components";
import { device } from "./Device";

const ImgSkills = styled.img`
  margin: 80px;
  width: 29%;
  ${"" /* @media ${device.mobileS} {
    margin: 15px;
    width: 15%;
  }
  @media ${device.mobileL} {
    margin: 30px;
    width: 20%;
  } */}
  @media ${device.laptop} {
    display: none;
  }
`;
const CirclesContent = styled.div`
  ${"" /* justify-content: center; */}
  display: flex;
`;

const CircleSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px;

  @media ${device.tablet} {
    margin: 15px;
  }
`;

const CircleContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;

  @media ${device.tablet} {
    width: 62px;
    height: 59px;
    border-radius: 50%;
  }
`;
const CircleText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 180px;
  background: white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    width: 53px;
    height: 50px;
  }

  span {
    font-weight: bold;
    color: rgb(48, 48, 48);
    text-shadow: 1px 1px rgba(0, 0, 0, 0.2);

    @media ${device.tablet} {
      font-size: 5px;
    }
    &:nth-child(1) {
      font-size: 1.8rem;
      @media ${device.tablet} {
        font-size: 7px;
      }
    }
  }
`;
const CircleTitle = styled.div`
  display: inline-block;
  text-align: center;
  width: 100%;

  @media ${device.tablet} {
    font-size: 7px;
    overflow-wrap: break-word;
    padding: 9px 5px 2px;

    & + p {
      margin-top: 0;
      color: purple;
    }
  }
`;

const CircleCanvas = styled.canvas`

}
`;

export {
  CirclesContent,
  CircleSection,
  CircleContent,
  CircleText,
  CircleTitle,
  CircleCanvas,
  ImgSkills,
};
